import {Transition, TransitionChild} from "@headlessui/react";
import {t} from "i18next";
import React, {useEffect} from "react";

export const EventPaymentQRModal = (props) => {
	const {
		selectedEventDetails,
		eventPaymentQRModal,
		onResolve,
		onReject
	} = props;

	const handleClose = () => {
		console.log("(EventPaymentQRModal) Inside Handle Close!");
		if (onReject) onReject({status: "failure"});
	}

	const handleConfirm = async () => {
		console.log("(EventPaymentQRModal) Inside Handle Confirm!");
		if (onResolve) onResolve({status: "success"});
	}

	useEffect(() => {
		console.log("(EventPaymentQRModal) Selected Event Details: ", selectedEventDetails);
	}, []);

	return (
		<>
			{document.body.classList.toggle("overflow-y-hidden", eventPaymentQRModal.show)}

			<Transition show={eventPaymentQRModal.show}>
				<div
					className={`min-h-[100dvh] h-[100dvh] max-h-[100dvh] 
                        min-w-[100dvw] w-[100dvw] max-w-[100dvw]
                        flex items-center justify-center 
                        fixed inset-0 z-[100]
                        bg-black/75 backdrop-blur-sm
                        data-[closed]:opacity-0
                        data-[enter]:duration-150 data-[enter]:data-[closed]:ease-out
                        data-[leave]:duration-300 data-[leave]:data-[closed]:ease-out`}
				>
					<TransitionChild
						enter="transition-transform duration-300 ease-out"
						enterFrom="translate-y-full"
						enterTo="translate-y-0"
						leave="transition-transform duration-300 ease-in"
						leaveFrom="translate-y-0"
						leaveTo="translate-y-full"
					>
						<div
							className="min-h-fit h-fit max-h-[100dvh]
                                landscape:min-w-[25vw] landscape:max-w-[90vw]

                                portrait:min-h-full portrait:h-full portrait:max-h-full
                                portrait:md:!min-h-fit portrait:md:!h-fit portrait:md:!max-h-fit

                                portrait:min-w-[100dvw] portrait:w-[100dvw] portrait:max-w-[100dvw]
                                portrait:md:min-w-[40vw] portrait:md:max-w-[90vw]

                                transform z-50 rounded-xl flex items-center justify-center
                                data-[enter]:duration-150 data-[enter]:data-[closed]:scale-75
                                data-[leave]:duration-300 data-[leave]:data-[closed]:scale-95"
						>
							<div
								className="form-modal-container h-[85vh]
                                    portrait:md:!h-[90vh] portrait:md:!max-h-[90vh]
                                    landscape:!min-w-[25vw] landscape:!w-[25vw] landscape:!max-w-fit
                                    portrait:!min-w-full portrait:!w-full portrait:!max-w-full
                                    portrait:md:!min-w-[60dvw] portrait:md:!w-[60dvw] portrait:md:!max-w-[60dvw]"
							>
								{/* Header */}
								<div className={"form-modal-header-container"}>
									{/* Header Title | Close Button */}
									<div className={"flex flex-row items-center justify-between"}>
										{/* Form Title */}
										<h2>{t("EVENTS_PAGE.PAYMENT_CONFIRMATION_MODAL.TITLE")}</h2>

										{/* Close Button */}
										<button onClick={handleClose}>
											<img
												className={"w-[75%] h-[75%]"}
												src={"/assets/close-icon.png"}
												alt={"Close"}
												title={"Close"}
											/>
										</button>
									</div>

									{/* Divider */}
									<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
								</div>

								{/* Body | Payment Information */}
								<div
									className={`relative form-modal-body-container
                                        !flex-1 !max-h-none !bg-transparent`}
								>
									{/* Ticket QR Code */}
									<div className={`flex-1 w-full flex items-center justify-center rounded-xl`}>
										<img
											src={selectedEventDetails.paymentInformation?.qrCodeURL}
											alt={"Payment QR Code"}
											className={`w-full aspect-auto`}
										/>
									</div>

									{/* Greeting for Received From */}
									<div>
										<p
											className={`flex-1 text-[#6D6D6D] font-custom-medium-italic
												portrait:text-[1rem] portrait:md:text-[0.8rem]
												portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
												landscape:text-[0.65rem] landscape:md:text-[0.7rem]
												landscape:jk:text-[0.75rem] landscape:lg:text-[0.85rem]
												leading-tight text-center`}
										>
											{t("EVENTS_PAGE.PAYMENT_CONFIRMATION_MODAL.RECEIVER_NAME")}
										</p>
										<p
											className={`flex-1 text-[##252525] font-custom-mono-bold
												portrait:text-[1rem] portrait:md:text-[0.8rem]
												portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
												landscape:text-[0.65rem] landscape:md:text-[0.7rem]
												landscape:jk:text-[0.75rem] landscape:lg:text-[0.85rem]
												leading-tight text-center`}
										>
											{selectedEventDetails.paymentInformation.receiverName}
										</p>
									</div>

									{/* Note */}
									<p
										className="flex-1 text-[#6D6D6D] font-custom-medium-italic
                                                    portrait:text-[1rem] portrait:md:text-[0.8rem]
                                                    portrait:jk:text-[1rem] portrait:lg:text-[1.25rem]
                                                    landscape:text-[0.65rem] landscape:md:text-[0.7rem]
                                                    landscape:jk:text-[0.75rem] landscape:lg:text-[0.85rem]
                                                    leading-tight text-center"
									>
										{t("EVENTS_PAGE.PAYMENT_CONFIRMATION_MODAL.NOTE.LABEL")} {t("EVENTS_PAGE.PAYMENT_CONFIRMATION_MODAL.NOTE.MESSAGE")}
									</p>
								</div>

								{/* Footer */}
								<div className={"form-modal-footer-container"}>
									{/* Divider */}
									<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

									{/* Submit Button Container */}
									<div className="flex items-center justify-end">
										{/* Submit Button */}
										<button
											onClick={handleConfirm}
											// onClick={() => console.log("Selected Event Details: ", selectedEventDetails)}
											className="form-modal-footer-container-submit-button"
										>
											<p>
												{t("EVENTS_PAGE.PAYMENT_CONFIRMATION_MODAL.SUBMIT")}
											</p>
											<svg
												viewBox="0 0 6 6"
												fill="none"
												id={"arrow-icon"}
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M3 1L5 3L3 5"
													id={"arrow-icon-tip"}
													stroke="black"
													strokeLinecap="square"
												/>
												<path
													d="M1 3L4 3"
													id={"arrow-icon-line"}
													stroke="black"
													strokeLinecap="square"
												/>
											</svg>
										</button>
									</div>
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</Transition>
		</>
	)
}
